import React, { useState, useEffect } from 'react'
import { firestore } from '../../../firebase'

function AddCategories({recipeId}) {

    const [categories, setCategories] = useState([])

    const [selectedCategory, setSelectedCategory] = useState()

    useEffect(() => {

        try {
            const categoriesRef = firestore.collection("recipeCategories");
            categoriesRef.onSnapshot(({docs}) => {
                const categories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setCategories(categories)
            })
        } catch (error) {
            
        }

    }, [])

    async function addCategory(e, category) {
        e.preventDefault();
        console.log(category)
        try {
            const recipeCategoriesRef = firestore.collection("recipes").doc(recipeId).collection("categories");
            const data = {
                category_id: category.id,
                category: category.category,
                imageUrl: category.featured_image
            }
            recipeCategoriesRef.add(data)
        } catch (error) {
            console.log(error)
        }

    }


    return (
        <div>
                        
            {categories && categories.map((category, index) => {
                return (
                    <div className="row" key={index}>
                        <div className="col-md-6 col-lg-3">
                            <p>{category.category}</p>
                        </div>
                        <div className="col-md-6">
                            <button onClick={e => addCategory(e, category)} className="btn btn-success btn-sm">Legg til</button>
                        </div>
                    </div>
                )
            })}
                        
        </div>
    )

}
export default AddCategories